import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { FontWeight } from '../../../../../styles/constants';
import { buildHeImgixUrl } from '../../../../images/imgix';

export const Container = styled.div`
  align-items: center;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  height: 56px;
  text-decoration: none;

  &:hover {
    background-color: ${ThemeColours.mono100};
  }
`;

export const LogoContainer = styled.div`
  flex: 0 0 40px;
  height: 40px;
  margin: 0 8px;
`;

export const Name = styled.span`
  color: ${ThemeColours.black};
  flex: 1 1 auto;
  font-weight: ${FontWeight.SEMI_BOLD};
`;

const makeSpecialtyIconUrl = (path: string) => buildHeImgixUrl(path, { w: 48, h: 48 });

export const PromotionIcon = styled.span<{ path: string }>`
  background-color: ${ThemeColours.primary300};
  background-image: url(${props => makeSpecialtyIconUrl(props.path)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 24px;
  border-radius: 100px;
  display: inline-block;
  height: 40px;
  padding: 8px;
  width: 40px;
`;
